import classNames from "classnames";
import SmallEmptyOpenedBox from "static/images/SmallEmptyOpenedBox.svg";

export const SmallEmptyOpenBox = ({
  text,
  alignToCenter = true,
}: {
  text: string;
  alignToCenter?: boolean;
}) => {
  return (
    <div
      className={classNames(
        "t-flex t-items-center t-gap-4 t-flex-col t-h-full",
        {
          "t-justify-center": alignToCenter,
        }
      )}
    >
      <img src={SmallEmptyOpenedBox} alt="SmallEmptyOpenedBox" />
      <span className="t-text-body-sm t-text-text-30">{text}</span>
    </div>
  );
};
